import { apiClient } from '@/shared/api'

import { TPartnership } from '../model/schema'

export const getPartnerships = async () => {
  const { data } = await apiClient.get<TPartnership[]>({
    endpoint: '/campaigns/partnerships',
  })

  return data
}
